import { CpPolicyHolderInterface } from '../../../interfaces/dto/policy-holder/cp-policy-holder-interface';

export class CpPolicyHolderModel implements CpPolicyHolderInterface {
  Address: string = '';
  Birthdate: string = '';
  City: string = '';
  Email: string = '';
  FiscalNumber: string = '';
  FiscalNumberCountryCode: string = '';
  Gender: string = '';
  Mobile: string = '';
  Name: string = '';
  NationalCardNumber: string = '';
  NationalCardNumberCountryCode: string = '';
  PostalCode: string = '';

  constructor(init?: Partial<CpPolicyHolderModel>) {
    Object.assign(this, init);
  }
}
